import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { ListadoRepMarketingComponent } from './listado-rep-marketing/listado-rep-marketing.component';

@Component({
  selector: 'app-rep-marketing',
  templateUrl: './rep-marketing.component.html',
  styleUrls: ['./rep-marketing.component.scss'],
  providers:[MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,ListadoRepMarketingComponent]
})
export class RepMarketingComponent{

  constructor(private loginService: LoginService,
  private carga:ListadoRepMarketingComponent) { }


  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
   this.carga.ExportTOExcel()
  }
}
